import React, { createContext } from 'react';
import CompA from './CompA';

const FirstName = createContext();
const LastName = createContext();

const Contexta = () => {
  return( <>

    <FirstName.Provider value={"M Moobeen"}>
    <LastName.Provider value={"Quader"}>
      <CompA />
    </LastName.Provider>
    </FirstName.Provider>
  </>
  )};

export default Contexta;

export {FirstName, LastName};
